
import { unitCategories } from "@/components/unit-converter/unit-categories";

export const measurementTypes = Object.entries(unitCategories).reduce((acc, [type, subcategories]) => {
  const capitalizedType = type.charAt(0).toUpperCase() + type.slice(1);
  
  acc[capitalizedType] = Object.entries(subcategories).reduce((subAcc, [subType, units]) => {
    const capitalizedSubType = subType
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
    
    subAcc[capitalizedSubType] = units.map(
      unit => unit.split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    );
    return subAcc;
  }, {});
  
  return acc;
}, {});

export const findCategoryForUnit = (unit: string): { category: string; subcategory: string } | null => {
  for (const [category, subcategories] of Object.entries(measurementTypes)) {
    for (const [subcategory, units] of Object.entries(subcategories)) {
      if (units.some(u => u.toLowerCase() === unit.toLowerCase())) {
        return { category, subcategory };
      }
    }
  }
  return null;
};
